import { Control, FieldPath, FieldValues, useController } from 'react-hook-form';
import { Switch } from '@givebutter/primitives/switch';
import { useWidgetFormContext } from 'components/form/WidgetFormContext';
import { twMerge } from 'tailwind-merge';
import { FormField } from './FormField';

interface FormSwitchProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  label?: string;
  description?: string;
  disabled?: boolean;
}

export const FormSwitch = <T extends FieldValues>({
  name,
  control,
  label,
  description,
  disabled,
}: FormSwitchProps<T>) => {
  const { compact } = useWidgetFormContext();
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name, control });

  return (
    <FormField description={description} error={error?.message}>
      <div className="flex items-center justify-between">
        {label && (
          <label
            htmlFor={name}
            className={twMerge(
              'text-sm',
              compact ? 'font-normal text-gray-600' : 'font-medium text-gray-900',
            )}
          >
            {label}
          </label>
        )}
        <Switch checked={!!value} onCheckedChange={onChange} disabled={disabled} id={name} />
      </div>
    </FormField>
  );
};
